import React, { useCallback } from 'react';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import { useStyles } from './FilterDatePicker.styles';

interface FilterDatePickerProps extends Omit<DatePickerProps<string, string>, 'renderInput'> {
  label: string;
}

export const FilterDatePicker: React.FC<FilterDatePickerProps> = ({ label, onChange, value, ...props }) => {
  const styles = useStyles();

  const handleChange = useCallback(
    (newValue: string | null) => {
      if (newValue === value) {
        return;
      }

      onChange?.(newValue);
    },
    [value, onChange]
  );

  return (
    <DatePicker
      {...props}
      value={value}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField {...params} fullWidth label={label} variant="outlined" className={styles.textField} />
      )}
    />
  );
};
